import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'rca-footer-component';
import Header, { headerPropTypes } from './Header/Header';
import ErrorBoundary from './ErrorBoundary';
import styles from './AppComponent.scss';

const AppComponent = ({ children, headerProps }) => (
  <div className={styles.normalBody}>
    <Header {...headerProps} />
    <ErrorBoundary>
      { children }
    </ErrorBoundary>
    <div className={styles.footerWrapper}>
      <Footer />
    </div>
  </div>
);

AppComponent.propTypes = {
  children: PropTypes.node,
  headerProps: PropTypes.shape(headerPropTypes),
};

export default AppComponent;
